/* Shared option validation and pricing. No network access and no Shopify writes. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.AMProductOptions = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var has = function (object, key) { return Object.prototype.hasOwnProperty.call(object, key); };
  var TYPES = ['select', 'radio', 'checkbox', 'text', 'textarea', 'number'];
  var CHOICE_TYPES = ['select', 'radio', 'checkbox'];
  var MAX_QUANTITY = 9999;
  var MAX_CART_ITEMS = 250;
  function fail(message) { var error = new Error(message); error.status = 400; throw error; }
  function object(value) { return value !== null && typeof value === 'object' && !Array.isArray(value) && (Object.getPrototypeOf(value) === Object.prototype || Object.getPrototypeOf(value) === null); }
  function text(value, name, required, limit) {
    if (value === undefined && !required) return '';
    if (typeof value !== 'string') fail(name + ' must be text.');
    var result = value.trim();
    if (required && !result) fail(name + ' is required.');
    if (result.length > (limit || 200) || /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(result)) fail(name + ' is too long or contains control characters.');
    return result;
  }
  function id(value, name) {
    var result = text(value, name, true, 160);
    if (/[\u0000-\u001f\u007f]/.test(result)) fail(name + ' cannot contain control characters.');
    return result;
  }
  function externalId(value) {
    if (typeof value === 'number') return Number.isSafeInteger(value) && value >= 0 ? String(value) : null;
    return typeof value === 'string' && value.trim() && value.length <= 160 ? value.trim() : null;
  }
  function boolean(value, name, fallback) {
    if (value === undefined) return fallback;
    if (typeof value !== 'boolean') fail(name + ' must be true or false.');
    return value;
  }
  function list(value, name) {
    if (value === undefined) return [];
    if (!Array.isArray(value) || value.length > 5000) fail(name + ' must be a list of IDs or names.');
    return Array.from(new Set(value.map(function (entry) { return text(entry, name + ' entry', true, 200); })));
  }
  function isChoice(field) { return CHOICE_TYPES.indexOf(field.type) !== -1; }
  function decimalNumber(value) {
    if (typeof value === 'number') {
      if (!Number.isFinite(value) || Math.abs(value) > Number.MAX_SAFE_INTEGER) return null;
      var written = String(value);
      if (!/[eE]/.test(written)) return written;
      var negative = value < 0 ? '-' : '';
      var pieces = written.replace(/^-/, '').split(/[eE]/);
      var digits = pieces[0].replace('.', '');
      var point = (pieces[0].indexOf('.') === -1 ? pieces[0].length : pieces[0].indexOf('.')) + Number(pieces[1]);
      return negative + (point <= 0 ? '0.' + '0'.repeat(-point) + digits : point >= digits.length ? digits + '0'.repeat(point - digits.length) : digits.slice(0, point) + '.' + digits.slice(point));
    }
    if (typeof value !== 'string' || value.length > 256) return null;
    var result = value.trim();
    if (!/^-?(?:0|[1-9]\d*)(?:\.\d+)?$/.test(result)) return null;
    var number = Number(result);
    return Number.isFinite(number) && Math.abs(number) <= Number.MAX_SAFE_INTEGER ? result : null;
  }
  function normalizeValue(field, value) {
    if (value === undefined || value === null || value === '') return field.type === 'checkbox' ? [] : '';
    if (field.type === 'checkbox') {
      if (!Array.isArray(value)) throw new Error('Choose one or more valid options.');
      if (value.length > field.choices.length || value.some(function (entry) { return typeof entry !== 'string'; })) throw new Error('Choose only valid options.');
      if (new Set(value).size !== value.length || value.some(function (entry) { return !field.choices.some(function (choice) { return choice.id === entry; }); })) throw new Error('Choose only valid options; duplicate selections are not allowed.');
      return field.choices.filter(function (choice) { return value.indexOf(choice.id) !== -1; }).map(function (choice) { return choice.id; });
    }
    if (isChoice(field)) {
      if (typeof value !== 'string' || !field.choices.some(function (choice) { return choice.id === value; })) throw new Error('Choose a valid option.');
      return value;
    }
    if (field.type === 'number') {
      var numeric = decimalNumber(value);
      if (numeric === null) throw new Error('Enter a valid number.');
      if (field.min !== undefined && Number(numeric) < field.min) throw new Error('Enter a number of at least ' + field.min + '.');
      if (field.max !== undefined && Number(numeric) > field.max) throw new Error('Enter a number no greater than ' + field.max + '.');
      return numeric;
    }
    if (typeof value !== 'string') throw new Error('Enter text.');
    var result = value.trim();
    if (result.length > field.maxLength) throw new Error('Use no more than ' + field.maxLength + ' characters.');
    if (/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(result)) throw new Error('Remove unsupported control characters.');
    if (field.validation === 'vin' && result) {
      result = result.toUpperCase();
      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(result)) throw new Error('Enter a 17-character VIN using letters and numbers, without I, O, or Q.');
    }
    return result;
  }
  function validateSet(input) {
    if (!object(input)) fail('An option set must be an object.');
    var result = { id: id(input.id, 'Option set ID'), name: text(input.name, 'Option set name', true, 200), enabled: boolean(input.enabled, 'Enabled', false), priority: input.priority === undefined ? 0 : input.priority, assignments: {}, fields: [] };
    if (!Number.isSafeInteger(result.priority) || Math.abs(result.priority) > 1000000) fail('Priority must be an integer between -1000000 and 1000000.');
    if (input.assignments !== undefined && !object(input.assignments)) fail('Assignments must be an object.');
    ['productIds', 'tags', 'vendors', 'productTypes'].forEach(function (key) { result.assignments[key] = list(input.assignments && input.assignments[key], 'Assignments ' + key); });
    if (!Array.isArray(input.fields) || input.fields.length > 100) fail('Fields must be a list of no more than 100 fields.');
    var previous = new Map();
    input.fields.forEach(function (source) {
      if (!object(source)) fail('Each option field must be an object.');
      var field = { id: id(source.id, 'Field ID'), label: text(source.label, 'Field label', true, 200), type: source.type, required: boolean(source.required, 'Required', false), help: text(source.help, 'Help', false, 2000), placeholder: text(source.placeholder, 'Placeholder', false, 500), conditions: [], choices: [] };
      if (previous.has(field.id)) fail('Duplicate field ID: ' + field.id + '.');
      if (TYPES.indexOf(field.type) === -1) fail('Unsupported field type: ' + String(field.type) + '.');
      if (source.validation !== undefined && source.validation !== '') {
        if (source.validation !== 'vin' || (field.type !== 'text' && field.type !== 'textarea')) fail('VIN validation is supported only on text fields.');
        field.validation = 'vin';
      }
      if (field.type === 'text' || field.type === 'textarea') {
        field.maxLength = source.maxLength === undefined ? (field.type === 'textarea' ? 2000 : 255) : source.maxLength;
        if (!Number.isSafeInteger(field.maxLength) || field.maxLength < 1 || field.maxLength > 10000) fail('Max length must be an integer between 1 and 10000.');
      } else if (source.maxLength !== undefined) fail('Max length is supported only on text fields.');
      ['min', 'max'].forEach(function (key) {
        if (source[key] === undefined || source[key] === null || source[key] === '') return;
        if (field.type !== 'number' || typeof source[key] !== 'number' || !Number.isFinite(source[key]) || Math.abs(source[key]) > Number.MAX_SAFE_INTEGER) fail(key + ' must be a finite number on a number field.');
        field[key] = source[key];
      });
      if (field.min !== undefined && field.max !== undefined && field.min > field.max) fail('Minimum cannot exceed maximum.');
      if (isChoice(field)) {
        if (!Array.isArray(source.choices) || !source.choices.length || source.choices.length > 250) fail('Choice fields need between 1 and 250 choices.');
        var choiceIds = new Set();
        field.choices = source.choices.map(function (sourceChoice) {
          if (!object(sourceChoice)) fail('Each choice must be an object.');
          ['price', 'priceCents', 'fee', 'feeCents', 'amount', 'amountCents'].forEach(function (key) { if (has(sourceChoice, key)) fail('Choice prices must come from a Shopify variant; remove ' + key + '.'); });
          var choice = { id: id(sourceChoice.id, 'Choice ID'), label: text(sourceChoice.label, 'Choice label', true, 200), variantId: sourceChoice.variantId === undefined || sourceChoice.variantId === null || sourceChoice.variantId === '' ? null : id(sourceChoice.variantId, 'Add-on variant ID') };
          if (choiceIds.has(choice.id)) fail('Duplicate choice ID: ' + choice.id + '.');
          choiceIds.add(choice.id);
          return choice;
        });
      } else if (source.choices !== undefined && (!Array.isArray(source.choices) || source.choices.length)) fail('Only choice fields can contain choices.');
      if (source.conditions !== undefined && (!Array.isArray(source.conditions) || source.conditions.length > 100)) fail('Conditions must be a list of no more than 100 rules.');
      field.conditions = (source.conditions || []).map(function (rule) {
        if (!object(rule)) fail('Each condition must be an object.');
        var dependencyId = id(rule.fieldId, 'Condition field ID');
        var dependency = previous.get(dependencyId);
        if (!dependency) fail('Condition ' + field.id + ' must reference an earlier field in this option set: ' + dependencyId + '.');
        if (['equals', 'not_equals', 'includes'].indexOf(rule.operator) === -1) fail('Unsupported condition operator.');
        if (rule.operator === 'includes' && dependency.type !== 'checkbox' && dependency.type !== 'text' && dependency.type !== 'textarea') fail('Includes conditions require a checkbox or text field.');
        var conditionValue;
        try {
          conditionValue = dependency.type === 'checkbox' && rule.operator === 'includes' ? normalizeValue(dependency, [rule.value])[0] : normalizeValue(dependency, rule.value);
        } catch (error) { fail('Invalid condition value for ' + dependencyId + ': ' + error.message); }
        if (conditionValue === undefined || rule.value === undefined || rule.value === null) fail('A condition needs a value.');
        return { fieldId: dependencyId, operator: rule.operator, value: conditionValue };
      });
      try { field.defaultValue = normalizeValue(field, source.defaultValue); } catch (error) { fail('Invalid default for ' + field.id + ': ' + error.message); }
      result.fields.push(field);
      previous.set(field.id, field);
    });
    return result;
  }
  function normalizeSets(sets) {
    if (!Array.isArray(sets) || sets.length > 1000) fail('Option sets must be a list of no more than 1000 sets.');
    var seen = new Set();
    return sets.map(function (set) { var result = validateSet(set); if (seen.has(result.id)) fail('Duplicate option set ID: ' + result.id + '.'); seen.add(result.id); return result; });
  }
  function applicableNormalized(sets, product) {
    if (!object(product)) return [];
    var productId = externalId(product.id);
    var tags = (Array.isArray(product.tags) ? product.tags : typeof product.tags === 'string' ? product.tags.split(',') : []).filter(function (tag) { return typeof tag === 'string'; }).map(function (tag) { return tag.trim().toLowerCase(); });
    var vendor = typeof product.vendor === 'string' ? product.vendor.trim().toLowerCase() : '';
    var productType = typeof (product.product_type || product.productType) === 'string' ? (product.product_type || product.productType).trim().toLowerCase() : '';
    return sets.filter(function (set) {
      var a = set.assignments;
      return set.enabled && (a.productIds.indexOf(productId) !== -1 || a.tags.some(function (tag) { return tags.indexOf(tag.toLowerCase()) !== -1; }) || a.vendors.some(function (entry) { return entry.toLowerCase() === vendor; }) || a.productTypes.some(function (entry) { return entry.toLowerCase() === productType; }));
    }).sort(function (a, b) { return b.priority - a.priority || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0); });
  }
  function applicableSets(sets, product) { return applicableNormalized(normalizeSets(sets), product); }
  function priceToCents(price) {
    if (typeof price !== 'string' || !/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(price)) fail('Shopify variant price must be a non-negative decimal string with at most two decimal places.');
    var parts = price.split('.');
    var cents = BigInt(parts[0]) * 100n + BigInt(((parts[1] || '') + '00').slice(0, 2));
    if (cents > BigInt(Number.MAX_SAFE_INTEGER)) fail('Shopify variant price exceeds the safe calculation limit.');
    return Number(cents);
  }
  function money(cents, currency) {
    if (!Number.isSafeInteger(cents)) fail('Money must be expressed in integer cents.');
    var code = currency === undefined ? 'CAD' : currency;
    if (typeof code !== 'string' || !/^[A-Z]{3}$/.test(code)) fail('Currency must be a three-letter uppercase code.');
    var amount = BigInt(cents);
    var absolute = amount < 0n ? -amount : amount;
    var whole = absolute / 100n;
    var fraction = String(absolute % 100n).padStart(2, '0');
    var signedWhole = amount < 0n ? (whole === 0n ? -0 : -whole) : whole;
    return new Intl.NumberFormat('en-CA', { style: 'currency', currency: code, currencyDisplay: 'code', minimumFractionDigits: 2, maximumFractionDigits: 2 }).formatToParts(signedWhole).map(function (part) { return part.type === 'fraction' ? fraction : part.value; }).join('');
  }
  function sameValue(left, right) {
    if (Array.isArray(left) && Array.isArray(right)) return left.length === right.length && left.every(function (item) { return right.indexOf(item) !== -1; });
    return left === right;
  }
  function conditionPasses(condition, values, visible, dependency) {
    if (!visible.has(condition.fieldId) || !has(values, condition.fieldId)) return false;
    var value = values[condition.fieldId];
    var equal = dependency.type === 'number' && value !== '' && condition.value !== '' ? Number(value) === Number(condition.value) : sameValue(value, condition.value);
    if (condition.operator === 'equals') return equal;
    if (condition.operator === 'not_equals') return !equal;
    return Array.isArray(value) ? value.indexOf(condition.value) !== -1 : typeof value === 'string' && typeof condition.value === 'string' && value.indexOf(condition.value) !== -1;
  }
  function put(target, key, value) { Object.defineProperty(target, key, { value: value, writable: true, configurable: true, enumerable: true }); }
  function quote(input) {
    if (!object(input)) fail('A quote request must be an object.');
    var sets = normalizeSets(input.sets || []);
    var applicable = applicableNormalized(sets, input.product);
    var errors = [];
    var output = { valid: false, errors: errors, visibleFields: [], selectedOptions: [], normalizedSelections: {}, extrasCents: 0, extrasTotalCents: 0, baseTotalCents: 0, totalCents: 0, items: [] };
    var addError = function (setId, fieldId, message) { errors.push({ setId: setId, fieldId: fieldId, message: message }); };
    var quantity = input.quantity === undefined ? 1 : input.quantity;
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > MAX_QUANTITY) addError(null, null, 'Quantity must be a whole number between 1 and ' + MAX_QUANTITY + '.');
    var variantId = externalId(input.variantId);
    var variants = input.product && Array.isArray(input.product.variants) ? input.product.variants : [];
    var baseVariant = variantId && variants.find(function (variant) { return variant && externalId(variant.id) === variantId; });
    var baseCents = 0;
    if (!baseVariant) addError(null, null, 'Choose a valid variant belonging to this product.');
    else {
      if (baseVariant.available !== true) addError(null, null, 'The selected product variant is unavailable.');
      try { baseCents = priceToCents(baseVariant.price); } catch (error) { addError(null, null, error.message); }
    }
    var catalogue = Array.isArray(input.catalogue) ? input.catalogue : object(input.catalogue) && Array.isArray(input.catalogue.products) ? input.catalogue.products : [];
    if (input.catalogue !== undefined && !Array.isArray(input.catalogue) && !(object(input.catalogue) && Array.isArray(input.catalogue.products))) addError(null, null, 'Catalogue must be a list of products.');
    var variantIndex = new Map();
    var ambiguousVariants = new Set();
    catalogue.concat(input.product ? [input.product] : []).forEach(function (product) {
      if (!product || !Array.isArray(product.variants)) return;
      product.variants.forEach(function (variant) {
        if (!variant || typeof variant !== 'object') return;
        var key = externalId(variant.id);
        if (!key) return;
        if (variantIndex.has(key)) {
          var existing = variantIndex.get(key);
          if (existing.price !== variant.price || existing.available !== variant.available) ambiguousVariants.add(key);
        } else variantIndex.set(key, variant);
      });
    });
    if (variantId && ambiguousVariants.has(variantId)) addError(null, null, 'The selected product variant has conflicting catalogue records. Refresh the catalogue.');
    var selections = input.selections === undefined ? {} : input.selections;
    if (!object(selections)) { addError(null, null, 'Selections must be an object.'); selections = {}; }
    Object.keys(selections).forEach(function (setId) {
      var matching = applicable.find(function (set) { return set.id === setId; });
      if (!matching) addError(setId, null, 'This option set does not apply to the selected product.');
      else if (!object(selections[setId])) addError(setId, null, 'Field selections must be an object.');
      else Object.keys(selections[setId]).forEach(function (fieldId) { if (!matching.fields.some(function (field) { return field.id === fieldId; })) addError(setId, fieldId, 'Unknown option field.'); });
    });
    var paid = new Map();
    var records = [];
    applicable.forEach(function (set) {
      var values = {};
      var visible = new Set();
      var fieldsById = new Map(set.fields.map(function (field) { return [field.id, field]; }));
      var supplied = object(selections[set.id]) ? selections[set.id] : {};
      put(output.normalizedSelections, set.id, values);
      set.fields.forEach(function (field) {
        if (!field.conditions.every(function (condition) { return conditionPasses(condition, values, visible, fieldsById.get(condition.fieldId)); })) return;
        visible.add(field.id);
        output.visibleFields.push({ setId: set.id, fieldId: field.id });
        var value;
        try { value = normalizeValue(field, has(supplied, field.id) ? supplied[field.id] : field.defaultValue); }
        catch (error) { addError(set.id, field.id, error.message); return; }
        put(values, field.id, value);
        var empty = Array.isArray(value) ? !value.length : value === '';
        if (empty) { if (field.required) addError(set.id, field.id, field.label + ' is required.'); return; }
        var chosen = isChoice(field) ? field.choices.filter(function (choice) { return Array.isArray(value) ? value.indexOf(choice.id) !== -1 : choice.id === value; }) : [];
        var display = isChoice(field) ? chosen.map(function (choice) { return choice.label; }).join(', ') : value;
        output.selectedOptions.push({ setId: set.id, fieldId: field.id, label: field.label, value: display });
        records.push({ set: set, field: field, value: display });
        chosen.forEach(function (choice) {
          if (!choice.variantId) return;
          var variant = variantIndex.get(choice.variantId);
          if (!variant) { addError(set.id, field.id, 'The add-on for ' + choice.label + ' was not found in the Shopify catalogue.'); return; }
          if (ambiguousVariants.has(choice.variantId)) { addError(set.id, field.id, 'The add-on has conflicting catalogue records. Refresh the catalogue.'); return; }
          if (variant.available !== true) { addError(set.id, field.id, 'The add-on ' + choice.label + ' is unavailable.'); return; }
          var cents;
          try { cents = priceToCents(variant.price); } catch (error) { addError(set.id, field.id, error.message); return; }
          if (!Number.isSafeInteger(output.extrasCents + cents)) { addError(set.id, field.id, 'Extras exceed the safe calculation limit.'); return; }
          output.extrasCents += cents;
          if (!paid.has(choice.variantId)) paid.set(choice.variantId, { id: choice.variantId, count: 0, labels: [] });
          var extra = paid.get(choice.variantId);
          extra.count += 1;
          extra.labels.push(set.name + ' / ' + field.label + ': ' + choice.label);
        });
      });
    });
    if (paid.size + 1 > MAX_CART_ITEMS) addError(null, null, 'Choose no more than ' + (MAX_CART_ITEMS - 1) + ' different add-on variants per product.');
    if (Number.isSafeInteger(quantity) && quantity > 0 && quantity <= MAX_QUANTITY) {
      paid.forEach(function (extra) {
        var extraQuantity = extra.count * quantity;
        if (!Number.isSafeInteger(extraQuantity) || extraQuantity > MAX_QUANTITY) addError(null, null, 'The combined quantity for an add-on must not exceed ' + MAX_QUANTITY + '. Reduce the product quantity or selected extras.');
      });
      output.baseTotalCents = baseCents * quantity;
      output.extrasTotalCents = output.extrasCents * quantity;
      output.totalCents = output.baseTotalCents + output.extrasTotalCents;
      if (![output.baseTotalCents, output.extrasTotalCents, output.totalCents].every(Number.isSafeInteger)) {
        addError(null, null, 'The total exceeds the safe calculation limit.');
        output.baseTotalCents = output.extrasTotalCents = output.totalCents = 0;
      }
    }
    var group = input.groupId === undefined ? 'preview:' + String(externalId(input.product && input.product.id) || 'product') + ':' + String(variantId || 'variant') : input.groupId;
    if (typeof group !== 'string' || !group.trim() || group.length > 200 || /[\u0000-\u001f\u007f]/.test(group)) addError(null, null, 'Option group ID must be text between 1 and 200 characters.');
    output.valid = errors.length === 0;
    if (!output.valid) return output;
    var properties = { _am_options_group: group, _am_options_role: 'base', _am_options_sets: JSON.stringify(applicable.map(function (set) { return set.id; })) };
    var labelCounts = new Map();
    records.forEach(function (record) { labelCounts.set(record.field.label, (labelCounts.get(record.field.label) || 0) + 1); });
    records.forEach(function (record) {
      var key = record.field.label;
      if (labelCounts.get(key) > 1) key = record.set.name + ' / ' + key;
      if (key.charAt(0) === '_') key = 'Option / ' + key;
      if (has(properties, key)) key = record.set.id + '.' + record.field.id + ' / ' + record.field.label;
      while (has(properties, key)) key = 'Option / ' + key;
      put(properties, key, record.value);
    });
    output.items.push({ id: variantId, quantity: quantity, properties: properties });
    paid.forEach(function (extra) {
      output.items.push({ id: extra.id, quantity: extra.count * quantity, properties: { _am_options_group: group, _am_options_role: 'extra', _am_options_parent: variantId, _am_options_sets: properties._am_options_sets, 'Option for': extra.labels.join('; ') } });
    });
    return output;
  }
  return Object.freeze({ validateSet: validateSet, applicableSets: applicableSets, quote: quote, priceToCents: priceToCents, money: money, MAX_QUANTITY: MAX_QUANTITY, MAX_CART_ITEMS: MAX_CART_ITEMS });
}));
